export default {
  dream: {
    title: "Vision & mission",
    titledetail:
      'Company Vision: Creating product, Igniting progress, Unleashing energy, A future to exchange',
    content: `The company vision is displayed at the entrance of the clean workshop on the first floor of Shanghai Superconductor Technology Co., Ltd. (hereinafter referred to as “Shanghai Superconductor” or “SST”), with the first half of the vision enlarged into a prominent slogan visible upon entering the factory area.
---Dr. Zhu Jiamin, the president, deeply interpreted the company vision: “In the power field, thanks to the zero-resistance characteristic of high-temperature superconductors, civil utility equipment such as superconducting cables and current limiters have been put into operation, and the first half of the company’s vision has begun to be realized. At the same time, with the support of high-temperature superconducting materials, significant progress has been made in the development of compact nuclear fusion. Research institutions and commercial companies in many developed countries and regions are gradually pushing forward the vision of changing the world. We look forward to realizing this vision as soon as possible and making the second half of the company’s vision a prominent slogan in the factory area.” Dr. Zhu is only 37 years old, and is the first employee of the company, experiencing the whole process of Shanghai Superconductor’s transition from the laboratory to industrialization. In the company, there are dozens of young and high-quality talents with more than ten years of working experience. A young team, solid technology, and leading product power are the foundations for the company to stand in the global high-temperature superconducting industry.
---In 2010, Shanghai positioned “high-temperature superconductor” as a strategic emerging industry, and this strategic decision initiated the city’s leading journey in the global high-temperature superconducting field. Not only does it have a complete industrial chain in the power field, but it also sees the emergence of leading commercial companies in future strategic industries such as nuclear fusion. On November 15, 2024, the Shanghai Economic and Information Commission, Development and Reform Commission, Education Commission, and Science and Technology Commission released the “Shanghai Implementation Plan for Promoting the High-Quality Development of New Material Industry (2025-2027),” which once again increased the policy push for the application of important fields of high-temperature superconductivity. The entire industry has entered an accelerated stage from 1 to 10 and from 10 to 100 after starting from scratch.
---Founded in 2011, Shanghai Superconductor has a domestic market share of over 80% and is the core supplier and exclusive supplier of several “global first” superconducting application projects. At present, the company’s annual production and sales volume has exceeded a thousand kilometers, covering several cutting-edge application fields such as controlled nuclear fusion, superconducting power, and high-field magnets.
---In the first 13 years of development, Shanghai Superconductor has received strong support from the Shanghai Municipal Committee and the municipal government. The Shanghai Technology Venture Capital Company, which has successfully incubated and invested in more than 100 Sci-Tech Innovation Board companies and is an important shareholder of the company, has improved the company’s governance structure since 2022 with the addition of more industrial investors, including Jingda Shares and Sheneng Group.
---Shanghai Superconductor has been deeply involved in several “global first” projects, including the large-aperture 20T strong magnetic field magnet of the United States CFS Company, the first 10kV three-phase coaxial high-temperature AC superconducting cable in China, the first 35kV kilometer-level high-temperature superconducting cable in China, the first MW-level superconducting induction heating device in the world, the electric magnetic levitation train, the 32.35T all-superconducting magnet, the 26.8T all-REBCO high-temperature superconducting magnet, and the Energy Singularity Honghuang-70. These projects have received high recognition from domestic and international customers. The successful implementation of these application/demonstration projects has played a leading role and also laid a foundation for Shanghai Superconductor to further expand its domestic and international markets.
---The first round of expansion of Shanghai Superconductor started at the end of 2022 and was successfully operated in the third quarter of 2024. The company’s production capacity now ranks among the world’s top. On the basis of the successful first round of expansion, Shanghai Superconductor has launched the second round of expansion. At this stage, the company’s products are in short supply, especially in the context of the accelerated global development of compact nuclear fusion based on high-temperature superconducting magnets. The stable and mass production of high-end products and the material support for various strategic research and development projects have become Shanghai Superconductor’s 24/7 production goals.
---Looking forward, the industry has taken its first small step. Under the hard work of professional teams in downstream application fields, the vision of “transforming the world with high-temperature superconducting materials” may soon be realized.
`,
    other: {},
  },
  events: {
    title: "Memorabilia",
    breadcrumb: "About Us > Memorabilia",
    timeline: [
      {
        year: "2025",
        items: [
          "Selected as one of the major projects in Shanghai 2025 plan",
          "The Phase II expansion project is proceeding smoothly, with an expected annual production capacity of 4,000km upon completion. The Phase III expansion project has been filed, and upon completion, Shanghai Superconductor's total production capacity will reach 20,000km/year.",
          'Awarded the title of "Shanghai Innovative Enterprise Headquarters".',
          "Selected as one of the top 10 events in the advanced materials field for 2024 by the Shanghai Municipal Commission of Economy and Informatization.",
        ],
      },
      {
        year: "2024",
        items: [
          "The Phase I expansion project was successfully completed by the end of 2024, with an annual production capacity reaching 2,000km.",
          "IPP, CAS, and its joint research team successfully developed a 26.8T all-REBCO high-temperature superconducting magnet, breaking the previous record of 26.4T for all-high-temperature superconducting magnets. Shanghai Superconductor supplied all the superconducting materials required for the project.",
          'Shanghai Superconductor supplied superconducting tapes (wires) in bulk to Lianovation Superconductor and completed delivery in 2024 for the high-temperature superconducting magnet-controlled silicon single-crystal growth device, which passes professional appraisal in 2025.',
          'Successfully passed the re-examination of the third batch of specialized and innovative “Little Giant” Enterprises by the Ministry of Industry and Information Technology; awarded the title of Shanghai "Science and Technology Innovation Action Plan" Science and Technology Little Giant for 2024, and recognized as a Shanghai Enterprise Technology Center; the Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications passes the assessment and was rated as "Good".',
          "Awarded the First Prize of China Electrotechnical Society Science and Technology Progress Award for 2023, the First Prize of China Electric Power Science and Technology Award, and the Second Prize of Science and Technology Award from Beijing and Sichuan.",
          "Selected as a typical case of national patient capital investment in the “2024 CCTV Finance and Economic Power Annual Ceremony‘ as a national case for the year."
        ],
      },
      {
        year: "2023",
        items: [
          "Complete the overall relocation, and the Phase I factory in Kangqiao is put into use. Launch a comprehensive expansion plan to enhance production capacity and tape (wire) delivery capabilities in all aspects.",
          "Receive another large-scale purchase order from Energy Singularity and complete delivery in 2024 for the large-aperture strong magnetic field Jingtian magnet, which completed its first round of current-carrying experiments in 2025 with a magnetic field strength reaching 21.7T.",
          'Win the bid for the high-performance YBCO high-temperature superconducting material procurement project from the Southern Power Grid, for use in a 10MJ high-temperature superconducting energy storage system, which is part of the National Key Research and Development Program.',
          'Become a member unit of the Shanghai Future Industry Advanced Nuclear Energy Expert Committee.',
        ],
      },
      {
        year: "2022",
        items: [
          "Complete equity restructuring, forming a new equity structure with listed companies, management teams, state-owned capital, and mainstream investment institutions as the main shareholders.",
          "Receive a large-scale purchase order from Energy Singularity and complete delivery in 2023 for the all-superconducting tokamak device Honghuang-70(HH70). ",
          'Receive a purchase order from IPP, CAS, and complete delivery in 2022 for the 24.1T all-REBCO high-temperature superconducting magnet. This magnet is the first all-REBCO closely-wound superconducting magnet over 20T in China, and all the superconducting tapes (wires) used are supplied by Shanghai Superconductor.',
          'Three scientific research projects, including "High Current Density High-Temperature Superconducting Conductor Technology for Strong Magnet Technology" led by Shanghai Superconductor, successfully passed the joint acceptance by the expert group organized by the Shanghai Municipal Science and Technology Commission.',
          'The Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications passes the acceptance.',
        ],
      },
      {
        year: "2021",
        items: [
          "Win the bid for the procurement project of superconducting coil for the electric aircraft at University of Lorraine in France. It is the first project that Shanghai Superconductor has won internationally",
          "The company's project “Key Technologies for the Preparation of High-Temperature Superconducting Tapes and Industrialization” has obtained certificate for scientific and  technological achievement.",
          'Awarded the titles of Shanghai “Specialized and Innovative” small and medium-sized enterprise and special and innovative “Little Giant” enterprise by the Ministry of Industry and Information Technology ',
        ],
      },
      {
        year: "2020",
        items: [
          "Secure an order for superconducting magnet to be used in small-scale MRI imaging equipment from the University of Cambridge and complete delivery in 2021. This is the first magnet order for Shanghai Superconductor in the international market.",
          "Begin to supply superconducting tapes (wires) in bulk to Lianovation Supercondtor for the world's first MW-level high-temperature superconducting induction heating device, which was successfully put into operation in 2023.",
          "Win the bid for the second-generation high-temperature superconducting tape (wire) procurement project for Shanghai Jiao Tong University and complete delivery in 2021. The tapes (wires) are used in CRRC’s high-temperature superconducting electric maglev project, which completed its first trial operation in 2023. It is China’s first high-temperature superconducting electric levitation all-factor experimental system.",
          "Receive large-scale purchase order from ZTT and complete delivery in 2021 for the Southern Power Grid's 10kV three-phase coaxial high-temperature AC superconducting cable demonstration project. Successfully tested in 2021, it is the world's first superconducting cable demonstration project applied in high-load density power supply areas.",
          'Awarded the title of “Shanghai Key Laboratory of High-Temperature Superconducting Materials and Application Technology” by Shanghai Municipal Science and Technology Commission',
          "Establishment of the Pudong New Area Enterprise Postdoctoral Research Station - Shanghai Superconductor Technology Co., Ltd. Branch.",
        ],
      },
      {
        year: "2019",
        items: [
          "Receive a large-scale purchase order from Shanghai Cable Research Institute and complete delivery in 2020. The company’s superconducting tapes (wires) are used in China’s first 35-kV kilometer-scale high-temperature superconducting cable demonstration project, which successfully went into operation in Shanghai in 2021. This project features the longest and largest-capacity 35-kV fully-commercialized high-temperature superconducting cable in the world",
          "Win the bid for the 'Development of 160kV superconducting DC resistive current limiter' project from Guangdong Power Grid. It is Shanghai Superconductor's first domestic order worth tens of millions of yuan, and the company completed the supply of double-sided encapsulated stainless steel second-generation high-temperature superconducting tapes (wires) in the same year",
          "Sign large-scale purchase orders with UK Tokamak Energy and US CFS, and complete delivery in 2019 and 2020 respectively. Both are used for the development of strong-field magnets for controlled nuclear fusion. UK Tokamak Energy completed the winding of DEMO4 magnet in February 2023, and US CFS successfully wound a 20T strong magnetic field magnet and passed the test in September 2021.",
          "Provide high-temperature superconducting tapes (wires) to the team at the Institute of Electrical Engineering, Chinese Academy of Sciences, in the development of the end coil for a 32.35T all-superconducting magnet, setting a new world record.",
          "Completion of the first long-tape (wire) coating experiment on domestic substrate, accelerating the research process for substrate localization.",
          "Shanghai Superconductor key material and application industrialization base project achieves results appraisal.",
        ],
      },
      {
        year: "2018",
        items: [
          'Hold “Shanghai High-Temperature Superconductor Conference 2018”',
          "Become a member of the National Superconducting Standardization Technical Committee",
        ],
      },
      {
        year: "2017",
        items: [
          "Win the bid for the YBCO high-temperature superconducting tape (wire) procurement project for Beijing Jiaotong University and complete delivery in 2018. The tapes (wires) are used for Zhongtian Technology's 220kV AC resistive-type superconducting fault current limiter project, which is part of the “National 863 Program” and passed acceptance in 2018.",
          "Another order from UK Tokamak Energy, commencing bulk supplies to international nuclear fusion projects",
        ],
      },
      {
        year: "2016",
        items: [
          "Secure procurement contracts from Germany KIT, Switzerland PSI, and UK Tokamak Energy. Begin to explore the international market",
          "Attend the ASC (Applied Superconductivity Conference) as the only domestic supplier of second-generation high-temperature superconducting tapes (wires) participating in the exhibition",
          'As a highlight project of Shanghai, Shanghai Superconductor’s technological achievements are selected and unveiled in the National “12th Five-Year Plan” Scientific and Technological Innovation Achievement Exhibition',
        ],
      },
      {
        year: "2015",
        items: [
          "Win the bid for the YBCO superconducting tape (wire) procurement project for superconducting magnets at the Institute of Electrical Engineering, Chinese Academy of Sciences, it is Shanghai Superconductor's first successful bid in China, marking the beginning of its official sales activities",
          "The company's R&D center in Zhangjiang High-Tech Park is put into use",
          'Awarded the title of “High-tech Enterprise”',
        ],
      },
      {
        year: "2014",
        items: [
          "Develop world-class low-resistance/zero-resistance joint technology, further accelerating the industrialization process of high-temperature superconducting tapes (wires)",
        ],
      },
      {
        year: "2013",
        items: [
          "Overcome the production equipment and process challenges for large-scale industrialization of second-generation high-temperature superconducting tapes (wires), and independently build China's first kilometer-level production line for such tapes (wires)",
        ],
      },
      {
        year: "2012",
        items: ["Complete the fabrication process of superconducting tapes (wires) based on substrate technology and layout the proprietary equipment."],
      },
      {
        year: "2011",
        items: ["Shanghai Superconducting Technology Co., Ltd. established"],
      },
      {
        year: "2010",
        items: [
          "Successfully developed China's first 100-meter-level second-generation high-temperature superconducting tape (wire), with a current-carrying capacity of 300A and extremely high cost-effectiveness, laying the foundation for the industrialization of the tape (wire)",
        ],
      },
    ],
  },
  introduction: {
    title: "Company Profile",
    content: `Shanghai Superconductor Technology Co., Ltd. (hereinafter referred to as “Shanghai Superconductor” or “SST”) is a high-tech enterprise specializing in the R&D, production, and sales of high-temperature superconducting materials. The company’s core business covers high-temperature superconducting tapes (wires) and related technical services, with products widely applied in cutting-edge technological fields such as controlled nuclear fusion, superconducting power, and high-field magnets. Shanghai Superconductor is committed to becoming a global leader in the superconducting field. With its excellent product performance, high cost-effectiveness, and comprehensive technical services, Shanghai Superconductor has grown into one of the world’s core suppliers of second-generation high-temperature superconducting materials after years of development, with an annual production and sales volume of over thousands of kilometers.
---The company’s second-generation high-temperature superconducting tapes (wires) have been appraised by domestic authoritative institutions as reaching the advanced level of international counterparts, with low-temperature strong-field characteristics, superconducting low-resistance joints, and fiber-optic embedded superconducting tapes (wires) and monitoring technologies reaching the world-leading level. Multiple international authoritative institutions have assessed that the tape (wire) products’ performance indicators rank in the top 20% globally, with a higher cost-effectiveness than domestic and international counterparts.
---Closely following the national strategy and targeting market demands in the superconducting application field, Shanghai Superconductor has always adhered to product development and technological innovation. The company has successively undertaken several national and Shanghai municipal scientific and technological projects, including the “National Key Research and Development Plan” and the “Shanghai Science and Technology Commission Major Special Project,” and has been awarded special support from Shanghai’s strategic emerging industries. It has formed an integrated business system covering research, mass production, quality control, and technical services. The company is a national specialized and innovative “Little Giant” Enterprise, Shanghai “Small Giant Technology Cultivation Enterprise”, Shanghai “specialized and innovative” small and medium-sized enterprise, “Shanghai Recognized Enterprise Technology Center”, “Shanghai Patent Pilot Enterprise” and a “Pudong New Area Corporate Postdoctoral Research Workstation.” It has established “Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications” and the “Shanghai Engineering Research Center of Superconductor Material and System.” Committed to technological breakthroughs and innovation, the company has obtained over 90 independent intellectual property rights, led or participated in the drafting of eight national, industry, or group standards, and has won honors such as the First Prize of China Nonferrous Metals Industry Science and Technology Award, the First Prize of China Electrotechnical Society Science and Technology Progress Award, and the First Prize of China Electric Power Science and Technology Award.
---With its excellent product performance and high-quality services, Shanghai Superconductor has established a stable and diversified high-quality customer base, providing products and services to more than 180 units worldwide. The company has established close cooperative relationships with domestic and international enterprises and research institutions, including China Southern Power Grid, China State Grid, the Institute of Plasma Physics of the Chinese Academy of Sciences, the Institute of Electrical Engineering of the Chinese Academy of Sciences, the United States MIT, Germany KIT, the United States CFS Company, the United Kingdom TE Company, New Zealand RRI Institute, Energy Singularity, and Lianovation Superconductor. In the future, Shanghai Superconductor will continue to adhere to the core concept of technological innovation, deepen domestic market development, actively expand into international markets, strengthen international cooperation, expand application fields, and further promote the commercialization of superconducting technology to contribute to the new era of superconducting technology.
`,
  },
  partners: {
      title: "Partners",
    subtitle: "Strong cooperation, driving the development of high-temperature superconducting industry",
    content: [
      {
        url: "/images/partners/中国科学院合肥物质科学研究院.jpg",
        alt: "Hefei Institutes of Physical Science, Chinese Academy of Sciences",
        altdetail: "Hefei Institutes of Physical Science, Chinese Academy of Sciences",
        desc: "CORC, superconducting magnet， controlled nuclear fusion",
      },
      {
        url: "/images/partners/中国科学院电工研究所.jpg",
        alt: "Institute of Electrical Engineering, Chinese Academy of Sciences",
        altdetail: "Institute of Electrical Engineering, Chinese Academy of Sciences",
        desc: "superconducting magnetic energy storage, superconducting magnet",
      },
      {
        url: "/images/partners/南方电网.jpg",
        alt: "China Southern Power Grid",
        altdetail: "China Southern Power Grid",
        desc: "superconducting synchronous compensator, superconducting transformer",
      },
      {
        url: "/images/partners/能量奇点.jpg",
        alt: "Energy Singularity",
        altdetail: "Energy Singularity",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/MIT.jpg",
        alt: "MIT",
        altdetail: "MIT",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/KIT.jpg",
        alt: "KIT",
        altdetail: "KIT",
        desc: "CORC, superconducting magnet",
      },
      {
        url: "/images/partners/CFS.jpg",
        alt: "CFS",
        altdetail: "CFS",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/Tokamak Energy.jpg",
        alt: "Tokamak Energy",
        altdetail: "Tokamak Energy",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/江西联创光电超导应用有限公司.jpg",
        alt: "Jiangxi Lianovation Superconductor",
        altdetail: "Jiangxi Lianovation Superconductor",
        desc: "superconducting induction heating",
      },
      {
        url: "/images/partners/上海电缆研究所有限公司.jpg",
        alt: "Shanghai Electric Cable Research Institute",
        altdetail: "Shanghai Electric Cable Research Institute",
        desc: "superconducting cable",
      },
      {
        url: "/images/partners/National MagLab.jpg",
        alt: "National MagLab",
        altdetail: "National MagLab",
        desc: "high-field magnet, fusion magnet",
      },
      {
        url: "/images/partners/CERN.jpg",
        alt: "CERN",
        altdetail: "CERN",
        desc: "current leads, superconducting magnet",
      },
      {
        url: "/images/partners/PPPL.jpg",
        alt: "Princeton Plasma Physics Laboratory",
        altdetail: "Princeton Plasma Physics Laboratory",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/RRI.jpg",
        alt: "RRI",
        altdetail: "RRI",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/CEA.jpg",
        alt: "CEA",
        altdetail: "CEA",
        desc: "CORC, superconducting magnet",
      },
      {
        url: "/images/partners/中车长春轨道客车股份有限公司.jpg",
        alt: "CRRC Changchun Railway Vehicles",
        altdetail: "CRRC Changchun Railway Vehicles",
        desc: "superconducting maglev",
      },
      {
        url: "/images/partners/University of Cambridge.jpg",
        alt: "University of Cambridge",
        altdetail: "University of Cambridge",
        desc: "MRI, superconducting magnet",
      },
      {
        url: "/images/partners/中国电力科学研究院有限公司.jpg",
        alt: "China Electric Power Research Institute",
        altdetail: "China Electric Power Research Institute",
        desc: "superconducting current limiter",
      },
      {
        url: "/images/partners/中天集团上海超导技术有限公司.jpg",
        alt: "Zhongtian Group Shanghai Superconductor Technology",
        altdetail: "Zhongtian Group Shanghai Superconductor Technology",
        desc: "superconducting cable",
      },
      {
        url: "/images/partners/清华大学.jpg",
        alt: "Tsinghua University",
        altdetail: "Tsinghua University",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/中国科学院高能物理研究所.jpg",
        alt: "Institute of High Energy Physics, Chinese Academy of Sciences",
        altdetail: "Institute of High Energy Physics, Chinese Academy of Sciences",
        desc: "low-temperature conductor",
      },
      {
        url: "/images/partners/上海交通大学.jpg",
        alt: "Shanghai Jiao Tong University",
        altdetail: "Shanghai Jiao Tong University",
        desc: "superconducting maglev， CORC",
      },
      {
        url: "/images/partners/中国科学院近代物理研究所.jpg",
        alt: "Institute of Modern Physics, Chinese Academy of Sciences",
        altdetail: "Institute of Modern Physics, Chinese Academy of Sciences",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/陕西星环聚能科技有限公司.jpg",
        alt: "Shanxi Startorus Fusion",
        altdetail: "Shanxi Startorus Fusion",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/北京交通大学.jpg",
        alt: "Beijing Jiaotong University",
        altdetail: "Beijing Jiaotong University",
        desc: "superconducting cable, superconducting current limiter",
      },
      {
        url: "/images/partners/CNRS.jpg",
        alt: "Centre national de la recherche scientifique",
        altdetail: "Centre national de la recherche scientifique",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/PSI.jpg",
        alt: "Paul Scherrer Institut",
        altdetail: "Paul Scherrer Institut",
        desc: "controlled nuclear fusion",
      },
      {
        url: "/images/partners/ACT.jpg",
        alt: "Advaned Conductor Technologies",
        altdetail: "Advaned Conductor Technologies",
        desc: "CORC",
      },
      {
        url: "/images/partners/ENEA.jpg",
        alt: "ENEA",
        altdetail: "ENEA",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/西南交通大学.jpg",
        alt: "Southwest Jiaotong University",
        altdetail: "Southwest Jiaotong University",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/华中科技大学.jpg",
        alt: "Huazhong University of Science and Technology",
        altdetail: "Huazhong University of Science and Technology",
        desc: "superconducting magnet",
      },
      {
        url: "/images/partners/Airbus.jpg",
        alt: "Airbus UpNext SAS",
        altdetail: "Airbus UpNext SAS",
        desc: "superconducting electric aircraft",
      },
      {
        url: "/images/partners/VEIR.jpg",
        alt: "VEIR, Inc",
        altdetail: "VEIR, Inc",
        desc: "superconducting cable",
      },
      {
        url: "/images/partners/Supergrid.jpg",
        alt: "Supergrid Institute SAS",
        altdetail: "Supergrid Institute SAS",
        desc: "superconducting current limiter",
      },
      {
        url: "/images/partners/上海翌曦科技发展有限公司.jpg",
        alt: "Shanghai Tixi Technology",
        altdetail: "Shanghai Tixi Technology",
        desc: "superconducting magnet",
      },
      // {
      //   url: "/images/partners/Renaissance Fusion.jpg",
      //   alt: "Renaissance Fusion",
      //   altdetail: "Renaissance Fusion",
      //   desc: "controlled nuclear fusion",
      // },
      {
        url: "/images/partners/University of Lorraine.jpg",
        alt: "University of Lorraine",
        altdetail: "University of Lorraine",
        desc: "superconducting electric aircraft",
      },
    ],
  },
  honors: {
    title: "Honors & Qualifications",
    subtitle: "Multiple national and provincial-level honors and qualifications",
    content:
      'Shanghai Superconductor has received multiple national and provincial-level honors and qualifications. In 2014, the Shanghai Science and Technology Commission authorized the establishment of the "Shanghai Superconductor Material and System Engineering Research Center" (Dr. Zhiyong Hong as the director of the research center), and in 2018, it was awarded the title of Shanghai Patent Work Pilot Enterprise. In 2020, the Shanghai High-Temperature Superconductor Material and Application Technology Key Laboratory was established (Dr. Jiamin Zhu as the director of the key laboratory), and in 2021, it was awarded the title of National Specialized and Innovative "Little Giant" Enterprise, Shanghai "Specialized and Innovative" Small and Medium-sized Enterprise, and Shanghai Technology Little Giant Enterprise. ',
    list: [
      {
        title: 'Specialized and Innovative “Little Giant” Enterprise recognized by the Ministry of Industry and Information Technology',
        image:
          "/images/honors/工信部专精特新小巨人企业（2024-9-2通过复核）.jpg",
      },
      {
        title: "National Intellectual Property Advantage Enterprise",
        image: "/images/honors/国家知识产权优势企业.jpg",
      },
      {
        title: "High Technology Enterprise",
        image: "/images/honors/高新技术企业.png",
      },
      {
        title: 'Shanghai “Specialized and Innovative” Small and Medium-sized Enterprise',
        image: "/images/honors/上海市专精特新中小企业（2023-4-19通过复核）.png",
      },
      {
        title: "Shanghai Innovative Enterprise Headquarters",
        image: "/images/honors/上海市创新型企业总部.jpg",
      },
      {
        title: 'Shanghai Science and Technology "Little Giant" Enterprise',
        image: "/images/honors/上海市科技小巨人（培育）企业.jpg",
      },
      {
        title: "Shanghai Engineering Research Center of Superconductor Material and System",
        image: "/images/honors/上海超导材料及系统工程技术研究中心.jpg",
      },
      {
        title: "Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications ",
        image: "/images/honors/上海市高温超导材料与应用技术重点实验室.jpg",
      },
      {
        title: "Shanghai Center for Enterprise Technology",
        image: "/images/honors/上海市企业技术中心.jpg",
      },
      {
        title: "Enhanced Second-Generation High-Temperature Superconductiong Tape  A Level",
        image: "/images/honors/加强型二代高温超导带材 A级.png",
      },
      {
        title: "The Second-Generation High-Temperature Superconducting Tape  A Level",
        image: "/images/honors/第二代高温超导带材 A级.jpg",
      },
      {
        title: "Low-Resistance Internal Sealed Joint Second-Generation High-Temperature Superconducting Tape  B Level",
        image: "/images/honors/低阻内封接头第二代高温超导带材 B级.jpg",
      },
      {
        title: "the First Prize of China Electrotechnical Society Science and Technology Award",
        image: "/images/honors/中国电工技术学会科学技术奖-一等奖.jpg",
      },
      {
        title: "China Patent Excellence Award ",
        image: "/images/honors/中国专利优秀奖.jpg",
      },
      {
        title: "the First Prize of China Non-ferrous Metals Industry Science and Technology Award",
        image: "/images/honors/中国有色金属工业科学技术奖-一等奖.jpg",
      },
      {
        title: "the First Prize of The Creative Founder Award--Achievement Award",
        image: "/images/honors/发明创业奖成果奖-一等奖.jpg",
      },
      {
        title: "the First Prize of The Creative Founder Award--Innovation Award",
        image: "/images/honors/发明创业奖创新奖-一等奖.jpg",
      },
      {
        title: "the First Prize of Electric Power Science and Technology Progress Award",
        image: "/images/honors/电力科学技术进步奖一等奖.jpg",
      },
      {
        title: "Gold Award of the 35th Shanghai Excellent Invention Competition",
        image: "/images/honors/第三十五届上海市优秀发明-金奖.jpg",
      },
      {
        title: "the Second Prize of Beijing Science and Technology Award",
        image: "/images/honors/北京市科学技术奖-二等奖.png",
      },
      {
        title: "the Second Prize of Sichuan Natural Science Award",
        image: "/images/honors/四川省自然科学奖-二等奖.png",
      },
      {
        title: "the Second Prize of China Non-ferrous Metals Industry Science and Technology Award",
        image: "/images/honors/中国有色金属工业科学技术奖-二等奖.png",
      },
      {
        title: "Honorary Certificate From Ministry of Science and Technology(“12th Five-Year Plan” S&T Innovation Achievement Exhibition)",
        image: "/images/honors/科技部荣誉证书（十二五成就展）.png",
      },
      {
        title: 'The Second Prize in the Final of the "Startup in Shanghai" International Competition (Growth Group)',
        image: "/images/honors/国际创新创业大赛总决赛(成长组)二等奖.png",
      },
     
      {
        title: "Gold Award For Industrial Design by The 18th Session China International Industry Fair",
        image: "/images/honors/第18届工博会工业设计金奖.jpg",
      },
    ],
  },
  structure: {
    title: "Subsidiary Organizations",
    list: [
      {
        title: "Shanghai Engineering Research Center of Superconductor Material and System",
        image: "/images/structure/上海超导材料及系统工程技术研究中心.jpg",
        url: "center",
      },
      {
        title: "Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications",
        image: "/images/structure/上海市高温超导材料与应用技术重点实验室.jpg",
        url: "lab",
      },
      {
        title: "Hefei Heju Magnet Technology Co., Ltd.",
        image: "/images/structure/核聚磁体.jpg",
        url: "tech",
      },
      {
        title: "Hefei Shangchao Material Technology Co., Ltd.",
        image: "/images/structure/上超材料.jpg",
        url: "materials",
      },
    ],
    center: {
      title: "Shanghai Engineering Research Center of Superconductor Material and System",
      content: `Shanghai Engineering Research Center of Superconductor Material and System (hereinafter referred to as “Engineering Center”) was established in 2012 with the approval of Science and Technology Commission of Shanghai Municipality. Organized by Shanghai Superconductor Technology Co., Ltd., the Engineering Center is committed to fulfil industrialization of domestically produced high temperature superconducting materials and large-scale applications, as guided by Shanghai’s scientific and technological development needs.
---Dr. Zhiyong Hong serves as the director of the Engineering Center. At present, the Engineering Center has 31 professionals with senior titles, including 17 with doctoral and master's degrees. Among the core team, there is one awarded for “young outstanding talent”, one awarded for “academic/technical research leader”, two awarded for “Pujiang Talents”, and 3 awarded for “Young Rising-Stars”. The Engineering Center has assembled a technical committee of top Chinese experts and scholars in the field of superconducting technology and applications, providing strong support for the Engineering Center’s technical progress and development upgrades.

---The Engineering Center mainly focuses its research on 2G-HTS materials, superconducting material production equipment, superconducting utility applications, superconducting energy-saving applications, and superconducting magnet technology.

---Under the propulsion of the Engineering Center, Shanghai Superconductor Technology has achieved the initial phase of industrial domestic production of 2G-HTS tapes (wires). The production capacity, performance, cost-effectiveness and market share of the product tapes (wires) are in a leading position in China and among the top tier in the world..

---Relying on the support of Shanghai Superconductor, the Engineering Center focuses on firmly meeting the technical and production needs of downstream applications for high-performance superconducting materials. It works closely with downstream application enterprises and conducts technical research to ensure that it matches various application needs. The Engineering Center connects with global suppliers for components, to achieve rapid expansion and industrial production.

---Focusing on the industrialization and large-scale applications of domestically produced 2G-HTS materials, the Engineering Center and Shanghai Superconductor Technology have fully integrated their resources, continuously enhanced their autonomous R&D and engineering application capabilities, so as to provide strong support for the novel development and commercialisation of superconducting technology.`,
      other: {
        picture: {
          url: "/images/structure/上海超导材料及系统工程技术研究中心.jpg",
          alt: "Shanghai Engineering Research Center of Superconductor Material and System",
        },
      },
    },
    lab: {
      title: "Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications",
      content: `Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications (hereinafter referred to as “Key Laboratory”) was established in 2019 with the approval of Science and Technology Commission of Shanghai Municipality and is organized by Shanghai Superconductor Technology Co., Ltd. In response to the strategic needs of national cutting-edge materials development, the Key Laboratory focuses on major scientific and technological projects in Shanghai and the plan for building a scientific and technological innovation base, dedicated to overcoming the key technical bottlenecks in China’s high-temperature superconducting industry as well as its practical application.
      ---Dr. Zhu Jiamin serves as the director of the Key Laboratory. At present, the Key Laboratory boasts 37 professionals with senior titles, including 16 individuals holding doctoral and master's degrees and 1 young rising-star. The Key Laboratory has assembled an academic committee of renowned domestic experts and scholars in the field of superconductivity, providing strategic and forward-looking guidance on the scientific and innovative aspects of the laboratory's projects.
      ---The Key Laboratory mainly focuses on high-temperature superconducting material technology, high-temperature superconducting strong electromagnetics and applications, and high-temperature superconducting generic and cutting-edge technology.
      ---Relying on the industrialization strengths of Shanghai Superconductor and the scientific expertise of Shanghai Jiao Tong University, the Key Laboratory centers around high-temperature superconducting materials in order to develop a comprehensive innovation system for high-temperature superconducting application technology from the perspective of applied basic research. It solves and overcomes the scientific and engineering technical challenges faced in the development of high-temperature superconductors in material preparation and engineering applications, promotes the application of intelligent manufacturing in high-temperature superconductivity, and explores new models of cooperation with enterprises and universities. Currently, the Key Laboratory has provided critical technical and material support for several national major scientific and public livelihood projects.
      ---The Key Laboratory and Shanghai Superconductor have formed an Industry-Education-Research-Application model, gathering innovative resources and focusing on key areas of innovation to actively promote the development of high-temperature superconducting materials towards high performance and low cost. It fosters synergistic growth across upstream and downstream industries and contributes new impetus to the development of high-temperature superconducting technology, materials, and application industries.`,
      other: {
        picture2: {
          url: "/images/structure/上海市高温超导材料与应用技术重点实验室——学术委员会.jpg",
          alt: "Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications",
        },
        picture1: {
          url: "/images/structure/上海市高温超导材料与应用技术重点实验室.jpg",
          alt: "Shanghai Key Laboratory of High-Temperature Superconductor Materials and Applications",
        },
      },
    },
    tech: {
      title: "Hefei Heju Magnet Technology Co., Ltd.",
      content:
        "Hefei Heju Magnet Technology Co., Ltd. was established by Shanghai Superconductor and Institute of Plasma Physics, Chinese Academy of Sciences. The company specializes in high-temperature superconducting magnet technology, primarily focusing on controlled nuclear fusion applications. Located in Hefei, the company will gradually build a specialized team and procure equipment for manufacturing high-temperature superconducting magnets. It is committed to serving national major scientific projects and advancing the research, development, application, and promotion of high-temperature superconducting magnets.",
    },
    materials: {
      title: "Hefei Shangchao Material Technology Co., Ltd.",
      content:
        "Hefei Shangchao Material Technology Co., Ltd. was a holding subsidiary invested by Shanghai Superconductor in 2023. It was established against the background of the Institute of Plasma Physics’ industrial agglomeration for the needs of national major scientific projects and the guidance of the superconductivity field towards downstream enterprises to establish subsidiaries in Hefei. The company is building a high-temperature superconducting material production line in Hefei, aimed at the superior low-temperature strong magnetic field performance tape (wire) material required by the controlled nuclear fusion field, supplying high-performance high-temperature superconducting tapes (wires) in batches, and supporting the construction of major scientific engineering projects in China.",
    },
  },
};
